import { createUseStyles } from 'react-jss';


var styles = {
  checkboxWrapper: function checkboxWrapper(guidelines) {return {
      margin: {
        bottom: '3.2rem'
      },
      width: guidelines && '65%'
    };}
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map